import React from 'react'
import { LoginComponent } from '../components/auth/login'







export const Login = () => {
    return (
        <LoginComponent />
    )
}
